import React from 'react';
import Helmet from "react-helmet";
import {Card, Row, Col} from 'react-bootstrap';
import { Container } from 'reactstrap';
import { Link } from 'react-router-dom';
import speaker1 from '../../assets/images/contents/speaker5.jpg';

export const AssociateProfessorDrAidenDoherty = () => (
  <div>
    <Helmet>
      <title>The 6th International Conference on Soft Computing in Data Science 2021 (SCDS2021) - Keynote Speaker</title>
    </Helmet>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><Link to="/scds2021/home">Home</Link></li>
        <li class="breadcrumb-item active" aria-current="page">AssociateProfessorDrAidenDoherty</li>
      </ol>
    </nav>

    <Container> 
      <Row className="justify-content-md-center">  
        <Col md="auto">
          <Card>
            <Card.Img width="100px" height="220px" src={speaker1} alt="speaker image" /> 
          </Card>             
        </Col>
      </Row>
    </Container>

    <p style={{textAlign:'center'}}>
      <b>Associate Professor Dr. Aiden Doherty</b>
    </p>

    <p style={{textAlign:'center'}}>
      Oxford University, United Kingdom
    </p>

    <br/>

    <h4 style={{textAlign:'center'}}>Reproducible Machine Learning of Movement Behaviours in 
      Terrabytes of Wearables Data</h4>

    <p style={{ textAlign:'justify'}}><b>Abstract</b><br/>
      My group has worked closely with UK Biobank to measure physical activity status in ~100,000 participants who agreed to wear a wrist-worn device for 
      seven days. These measurements are now actively used by epidemiologists worldwide to demonstrate associations between physical activity, sleep, 
      circadian rhythms and disease outcomes. In this talk I will share my group’s work on reproducible machine learning of sleep and physical activity 
      behaviours; and how they are facilitating new genetic and epidemiological insights. I will also highlight the opportunities for collaboration between 
      clinicians and data scientists.
    </p>

    <p style={{ textAlign:'justify'}}><b>Biography</b><br/>
      I am an Associate Professor at the University of Oxford and lead Health Data Research UK’s national implementation project on reproducible machine 
      learning. My research group at Oxford develops reproducible methods to analyse wearable sensor data in very large health studies to better understand 
      the causes and consequences of disease. For example, we have developed methods to objectively measure physical activity in UK Biobank which are now 
      actively used by researchers worldwide to demonstrate new associations with cardiovascular disease, depression, mood disorders, and others. These have 
      allowed us to show that the lowest risk for cardiovascular disease in the UK Biobank cohort is seen at the highest level of accelerometer-measured 
      physical activity, whether total, moderate-intensity, or vigorous-intensity. find that physical activity has a very strong association with incident 
      cardiovascular disease. We have also developed machine learning methods to identify sleep and functional physical activity behaviours such as walking. 
      In addition, we have discovered the first genetic variants associated with machine-learned sensor phenotypes. This work shows the first genetic evidence 
      that physical activity might causally lower blood pressure
    </p>

    <p>Click this <a href = "https://www.ndph.ox.ac.uk/team/aiden-doherty" target="_blank" rel="noreferrer">link</a> to see his further detail bio. <br/>
    </p>

  </div>
)